import { useRef } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'next-i18next';
import zip from 'lodash/zip';

import { storeWithDistanceShape } from '@common/types/shops';
import { useStickyElement } from '@common/hooks/useStickyElement';
import StoreCard from '@common/components/StoreCard';
import LoadingIndicator from '@common/components/LoadingIndicator';

import {
  Wrapper,
  CountSticky,
  CountContainer,
  Count,
  CountLabel,
  CardsWrapper,
} from './SearchResults.styled';

const SearchResults = ({
  searchResults,
  sizeSymbols,
  dataTestId,
  loadingEnhancedResults,
}) => {
  const { t } = useTranslation();
  const stickyContentRef = useRef(null);
  const { shouldAnimate } = useStickyElement(stickyContentRef);

  return (
    <Wrapper>
      <CountSticky
        shouldAnimate={shouldAnimate}
        ref={stickyContentRef}
      >
        <CountContainer>
          <Count>{searchResults.length}</Count>
          <CountLabel>
            {t('storeFinder.otherStores.countLabel', 'Filialen')}
          </CountLabel>
        </CountContainer>
      </CountSticky>

      <CardsWrapper data-testid={dataTestId}>
        {loadingEnhancedResults && <LoadingIndicator withWrapper />}
        {zip(searchResults, sizeSymbols).map(([store, sizes]) => (
          <StoreCard
            key={store.id}
            store={store}
            sizes={sizes}
          />
        ))}
      </CardsWrapper>
    </Wrapper>
  );
};

SearchResults.propTypes = {
  searchResults: PropTypes.arrayOf(storeWithDistanceShape).isRequired,
  sizeSymbols: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string)),
  dataTestId: PropTypes.string,
  loadingEnhancedResults: PropTypes.bool,
};

SearchResults.defaultProps = {
  sizeSymbols: [],
  dataTestId: null,
  loadingEnhancedResults: false,
};

export default SearchResults;
